<template>
  <v-app :style="appStyle">
    <the-app-loader
      v-if="isLoading"
      data-test="loading"
    />
    <the-app-error
      v-else-if="error"
      :error="error"
      data-test="error"
    />
    <router-view
      v-else
      data-test="content"
    />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapGetters('core', ['error', 'isLoading']),
    appStyle() {
      const themeName = this.$vuetify.theme.dark ? 'dark' : 'light';
      return { background: this.$vuetify.theme.themes[themeName].background };
    },
  },
};
</script>

<style>
.theme--dark a,
.theme--dark .v-list-item__title a {
  color: #82b1ff;
}
</style>
